import * as React from 'react';
const ImageFileTypes = ['png', 'gif', 'jpg', 'svg'];
const Creative = ({ url, campaignId, campaignLink, settings, buildDeepLink }) => {
    if (ImageFileTypes.some(fileType => url.endsWith(fileType))) {
        return (React.createElement("a", { href: buildDeepLink({ campaignId, campaignLink }), target: "_blank", rel: "noopener noreferrer" },
            React.createElement("img", { loading: "lazy", src: url, height: "100%", width: "100%" })));
    }
    else {
        const urlWithClickTag = new URL(url);
        urlWithClickTag.searchParams.set('clickTag', buildDeepLink({ campaignId, campaignLink }));
        urlWithClickTag.searchParams.set('language', settings.language);
        urlWithClickTag.searchParams.set('currency', settings.currency);
        urlWithClickTag.searchParams.set('oddsFormat', settings.oddsFormat);
        urlWithClickTag.searchParams.set('apiHost', settings.apiHost);
        urlWithClickTag.searchParams.set('license', settings.license);
        if (campaignId) {
            urlWithClickTag.searchParams.set('campaignId', campaignId);
        }
        return (React.createElement("iframe", { src: urlWithClickTag.toString(), height: "100%", width: "100%", scrolling: "no", style: { border: 'none', overflow: 'hidden' } }));
    }
};
export default Creative;
//# sourceMappingURL=Creative.js.map